export const AD_NAME_REQUIRED = 'Ad name is required';
export const CREATIVE_URL_REQUIRED = 'Creative URL is required';
export const TAG_URL_REQUIRED = 'Tag URL is required';
export const TAG_TYPE_REQUIRED = 'Please select tag type';
export const TAG_POSITION_REQUIRED = 'Please select position';
export const DUPLICATE_BILLABLE_TAG = 'Only one Billable tag is allowed per ad';
export const DUPLICATE_CLICK_TAG = 'Only one Click tag is allowed per ad';
export const DUPLICATE_NON_BILLABLE_URL = 'Duplicate URL for Non-Billable tags';
export const SAVE_DISABLED_TOOLTIP = 'Please fix highlighted validation errors to save';

export const getAdTypeNotPermittedMessage = (adTypeDisplayName: string, adProductDisplayName: string): string =>
  `Ad type "${adTypeDisplayName}" is not permitted for ${adProductDisplayName} line items.`;

export const getCreativeTypeNotPermittedMessage = (creativeTypeDisplayName: string): string =>
  `Creative type "${creativeTypeDisplayName}" is not compatible with any permitted ad type for this line item.`;

export const getCreativeTypeNotSupportedByMutationMessage = (creativeTypeDisplayName: string): string =>
  `Creative type "${creativeTypeDisplayName}" cannot be created in this upload flow.`;
